module.exports = __webpack_public_path__ + "static/media/howto.fcf74635.pdf";